import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PricingTable from "../components/PricingTable";

const PlansPage = () => {
  const navigate = useNavigate();

  const plans = [
    {
      name: "Basic",
      oldPrice: "₹9,999",
      price: "₹4,999",
      off: "50% off",
      ideal: "1–2 hirings",
      searches: "Unlimited",
      views: 100,
      jobs: 3,
      emails: 500,
      validity: "30 days",
      highlight: false
    },
    {
      name: "Standard",
      oldPrice: "₹11,999",
      price: "₹5,999",
      off: "50% off",
      ideal: "5–8 hirings",
      searches: "Unlimited",
      views: 230,
      jobs: 10,
      emails: 1500,
      validity: "30 days",
      highlight: false
    },
    {
      name: "Premium",
      oldPrice: "₹14,999",
      price: "₹7,499",
      off: "50% off",
      note: "40% users bought this",
      ideal: "10–12 hirings",
      searches: "Unlimited",
      views: 450,
      jobs: 25,
      emails: 3000,
      validity: "30 days",
      highlight: true
    },
    {
      name: "Premium Pro",
      oldPrice: "₹29,999",
      price: "₹14,999",
      off: "50% off",
      ideal: "25–30 hirings",
      searches: "Unlimited",
      views: 1175,
      jobs: 30,
      emails: 9000,
      validity: "90 days",
      highlight: false
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />

      <div className="flex-grow pt-28 pb-16 max-w-7xl mx-auto px-4">

        {/* Heading */}
        <h1 className="text-4xl font-bold text-center text-gray-900 mb-12">
          Choose a plan based on your hiring needs
        </h1>

        {/* Enterprise Pricing Table */}
        <PricingTable
          plans={plans}
          onBuy={(plan) => navigate("/login?type=institution")}
        />

      </div>

      <Footer />
    </div>
  );
};

export default PlansPage;
